import React, { useEffect, useState } from 'react';
import { useLanguage } from '../context/LanguageContext';
import { Button } from './ui/button';
import { Menu, X, Globe, ChevronDown } from 'lucide-react';

const languages = [
  { code:'en', label:'English' },
  { code:'ar', label:'العربية' },
  { code:'fr', label:'Français' },
  { code:'es', label:'Español' },
];

export const Navbar = () => {
  const { language, setLanguage, t } = useLanguage();
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [langOpen, setLangOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 20);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id) => {
    document.getElementById(id)?.scrollIntoView({ behavior:'smooth' });
    setIsMobileMenuOpen(false);
  };

  const navItems = [
    { id:'about', label:t.nav.about },
    { id:'programs', label:t.nav.program },
    { id:'sectors', label:t.nav.sectors },
    { id:'startups', label:t.nav.startups },
    { id:'investors', label:t.nav.investors },
    { id:'partners', label:t.nav.partners },
    { id:'contact', label:t.nav.contact },
  ];

  return (
    <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-white/95 backdrop-blur-xl border-b border-slate-200 shadow-sm' : 'bg-white/90 backdrop-blur-md'}`}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-24">
          <button onClick={() => scrollToSection('home')} className="flex-shrink-0">
            <img src="/ateed-logo.svg" alt="ATEED - Business Incubator for Technology, Ras Al Khaimah, UAE" className="h-16 w-auto" />
          </button>

          <div className="hidden xl:flex items-center gap-1">
            {navItems.map(item => (
              <button key={item.id} onClick={() => scrollToSection(item.id)} className="px-3 py-2 text-sm font-medium text-slate-700 hover:text-[#0B4DA2] rounded-lg hover:bg-slate-100">
                {item.label}
              </button>
            ))}
          </div>

          <div className="flex items-center gap-2">
            <div className="relative">
              <button onClick={() => setLangOpen(v => !v)} className="flex items-center gap-2 px-3 py-2 rounded-lg border border-slate-200 bg-white text-sm font-semibold text-slate-700">
                <Globe className="w-4 h-4" />
                <span>{language.toUpperCase()}</span>
                <ChevronDown className="w-4 h-4" />
              </button>
              {langOpen && (
                <div className={`absolute mt-2 w-40 bg-white border border-slate-200 rounded-xl shadow-xl overflow-hidden ${language === 'ar' ? 'left-0' : 'right-0'}`}>
                  {languages.map(item => (
                    <button key={item.code} onClick={() => { setLanguage(item.code); setLangOpen(false); }} className={`w-full px-4 py-3 text-sm hover:bg-slate-50 ${language === 'ar' ? 'text-right' : 'text-left'} ${language === item.code ? 'font-bold text-[#0B4DA2]' : 'text-slate-700'}`}>
                      {item.label}
                    </button>
                  ))}
                </div>
              )}
            </div>

            <Button onClick={() => scrollToSection('apply')} className="hidden md:flex bg-[#D9A744] hover:bg-[#c69638] text-[#10243b] px-5 py-2 rounded-lg font-bold">
              {t.nav.apply}
            </Button>

            <button onClick={() => setIsMobileMenuOpen(v => !v)} className="xl:hidden p-2 text-slate-700">
              {isMobileMenuOpen ? <X className="w-6 h-6"/> : <Menu className="w-6 h-6"/>}
            </button>
          </div>
        </div>
      </div>

      {isMobileMenuOpen && (
        <div className="xl:hidden bg-white border-t border-slate-200 shadow-lg">
          <div className="px-4 py-4 space-y-1">
            {navItems.map(item => (
              <button key={item.id} onClick={() => scrollToSection(item.id)} className={`block w-full px-4 py-3 rounded-lg hover:bg-slate-50 text-slate-700 ${language === 'ar' ? 'text-right' : 'text-left'}`}>
                {item.label}
              </button>
            ))}
            <Button onClick={() => scrollToSection('apply')} className="w-full mt-3 bg-[#D9A744] hover:bg-[#c69638] text-[#10243b] rounded-lg font-bold">
              {t.nav.apply}
            </Button>
          </div>
        </div>
      )}
    </nav>
  );
};
